import { QA_SECTION_KEY } from '../../../constants/qa'
import { useScreen } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { FilterDivider } from '../../FilterDivider'

import { TableConfigButton } from './TableConfigButton'
import { QA_NAME_TABLE_CONTROL_BUTTONS_SECTION } from './TableControlButtons.constants'
import { getShowChangeViewTypeButton } from './TableControlButtons.utils'
import { TableControlButtonsActionsSelect } from './TableControlButtonsActionsSelect'
import { TableDensityButton } from './TableDensityButton'
import { TableRefreshButton } from './TableRefreshButton'
import { TableResetSortingButton } from './TableResetSortingButton'

import * as styles from './TableControlButtons.module.css'

function TableControlButtons({
  ChangeViewTypeButton,
  ConfigButton = TableConfigButton,
  DensityButton = TableDensityButton,
  RefreshButton = TableRefreshButton,
  ResetSortingButton = TableResetSortingButton,
  changeViewTypeButtonProps,
  className = styles.TableControlButtons,
  configButtonProps,
  densityButtonProps,
  keepChangeViewTypeButtonOnNarrowScreen,
  refreshButtonProps,
  resetSortingProps,
  ...restProps
}) {
  const { isMobileScreenSize, screenWidth } = useScreen()

  const showChangeViewTypeButton = getShowChangeViewTypeButton({
    ChangeViewTypeButton,
    keepOnNarrowScreen: keepChangeViewTypeButtonOnNarrowScreen,
    screenWidth,
  })

  const qaProps = getQaSelector(
    { value: QA_NAME_TABLE_CONTROL_BUTTONS_SECTION },
    QA_SECTION_KEY
  )

  return (
    <div {...qaProps} className={className}>
      {isMobileScreenSize ? (
        <TableControlButtonsActionsSelect
          {...restProps}
          ChangeViewTypeButton={
            showChangeViewTypeButton ? ChangeViewTypeButton : null
          }
          ConfigButton={ConfigButton}
          DensityButton={DensityButton}
          RefreshButton={RefreshButton}
          ResetSortingButton={ResetSortingButton}
          changeViewTypeButtonProps={changeViewTypeButtonProps}
          configButtonProps={configButtonProps}
          densityButtonProps={densityButtonProps}
          refreshButtonProps={refreshButtonProps}
          resetSortingProps={resetSortingProps}
        />
      ) : (
        <>
          <div className={styles.group}>
            {ResetSortingButton ? (
              <ResetSortingButton {...restProps} {...resetSortingProps} />
            ) : null}
            {RefreshButton ? (
              <RefreshButton {...restProps} {...refreshButtonProps} />
            ) : null}
            {DensityButton ? (
              <DensityButton {...restProps} {...densityButtonProps} />
            ) : null}
            {ConfigButton ? (
              <ConfigButton {...restProps} {...configButtonProps} />
            ) : null}
          </div>
          {showChangeViewTypeButton ? (
            <>
              <FilterDivider />
              <ChangeViewTypeButton {...changeViewTypeButtonProps} />
            </>
          ) : null}
        </>
      )}
    </div>
  )
}

export default TableControlButtons
